import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFound.css';

function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <div className="not-found-icon">
          <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="60" cy="60" r="55" stroke="#d4af37" strokeWidth="3" />
            <text x="60" y="75" fontSize="60" fontWeight="bold" fill="#d4af37" textAnchor="middle">
              404
            </text>
          </svg>
        </div>
        <h1>Page Not Found</h1>
        <p>Oops! The page you're looking for doesn't exist.</p>
        <div className="not-found-buttons">
          <button className="not-found-btn primary" onClick={() => navigate('/')}>
            Go Home
          </button>
          {/* <button className="not-found-btn secondary" onClick={() => navigate(-1)}>
            Go Back
          </button> */}
        </div>
      </div>
    </div>
  );
}

export default NotFound;
